<template>
  <div>
    <main>
      <slot></slot>
    </main>
  </div>
</template>

<script >
import { usePage } from '@inertiajs/vue3';

export default {
  name: 'AppLayout',
  
}
</script>
